import { useEffect, useState } from "react";
import api from "../../../services/api";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Input from "../../../components/atoms/input";
import Loading from "../../../components/atoms/loading";
import NavBar from "../../../components/organisms/navbar";
import Button from "../../../components/atoms/button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InputMaskCustom from "../../../components/atoms/input-mask-custom";
import Select from "../../../components/atoms/select";
import { Content } from "../styles";
import { FormContainer, FormGroup } from "../editUser/styles";
import EventIcon from "@mui/icons-material/Event";
import CloseIcon from "@mui/icons-material/Close";
import SecurityIcon from "@mui/icons-material/Security";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Typography, Select as MuiSelect, Box, List, Divider, Chip, ListItem, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

export const AdminEditUser = () => {
    const navigate = useNavigate();
    const { getToken } = useAuthenticate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        control,
        watch,
        getValues
    } = useForm();
    const [disabled, setDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [birth_date, setBirth_date] = useState("")
    const [tournaments, setTournaments] = useState<any>([])
    const [phone, setPhone] = useState("")
    const [roles, setRoles] = useState<any>([]);
    const [user, setUser] = useState<any>([]);
    const [tournamentModalOpen, setTournamentModalOpen] = useState(false);
    const [selectedTournaments, setSelectedTournaments] = useState<number[]>([]);
    const { id } = useParams();

    const belts = [
        { title: "Branca", option: 1 },
        { title: "Cinza", option: 2 },
        { title: "Amarela", option: 3 },
        { title: "Laranja", option: 4 },
        { title: "Verde", option: 5 },
        { title: "Azul", option: 6 },
        { title: "Roxa", option: 7 },
        { title: "Marrom", option: 8 },
        { title: "Preta", option: 9 },
    ]

    const onSubmit = (data: any) => {
        setDisabled(true);
        setLoading(true);
        api
            .put(
                `/admin/users/edit/${id}`,
                {
                    ...data,
                },
                {
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                    },
                }
            )
            .then(() => {
                toast.success("Usuário foi atualizado com sucesso!");
                setTimeout(() => {
                    navigate("/admin/users/management", { state: { userName: data.name } });
                }, 2000);
            })
            .catch(() => {
                setDisabled(false);
                setLoading(false);
                toast.error("Não foi possível atualizar atleta!");
            });
    };

    const fetchRoles = async () => {
        setLoading(true);
        await api.get(`/admin/roles`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            }
        }).then((res) => {
            setRoles(res.data)
        }).catch((err) => {
            console.log(err)
        })
    }

    const fetchTournaments = async () => {
        api.get('/managers/tournaments/info', {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }).then((res) => {
            setTournaments(res.data);
        }).catch((error) => {
            console.log(error);
        })
    }

    const fetchUser = async () => {
        setLoading(true)
        await api
            .get(`/admin/users/${id}`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            })
            .then((response) => {
                setUser(response.data);
                setValue("name", response.data.name);
                setValue("mother_name", response.data.mother_name);
                setValue("gym", response.data.gym);
                setValue("genre", response.data.genre?.toLowerCase());
                setPhone(response.data.phone)
                setBirth_date(response.data.birth_date)
                setValue("phone", response.data.phone)
                setValue("birth_date", response.data.birth_date)
                setValue("belt", response.data.belt)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
            });
    };

    useEffect(() => {
        fetchUser();
        fetchRoles();
        fetchTournaments();
    }, []);

    if (loading)
        return <Loading text="Aguarde, estamos processando suas informações." />;

    return (
        <>
            <NavBar />

            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2 }}>

                <Box sx={{ width: '76%', mt: 2 }}>
                    <Box sx={{ alignSelf: "start", mb: 2 }}>
                        <Typography variant="h4" sx={{ fontFamily: "inter, sans-serif" }}>
                            Edição de Usuário
                        </Typography>
                    </Box>
                    <FormContainer onSubmit={handleSubmit(onSubmit)}>

                        {/* Permissões */}
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Permissões
                        </Typography>
                        <Controller
                            name="permissions"
                            control={control}
                            defaultValue={{ add: [], remove: [] }}
                            render={({ field }) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                                    {roles.map((role: any) => {
                                        const userAlreadyHas = user.UserRole?.some((r: any) => r.roleId === role.id);
                                        const isAdded = (field.value.add || []).includes(role.id);
                                        const isRemoved = (field.value.remove || []).includes(role.id);
                                        const selected = (userAlreadyHas && !isRemoved) || isAdded;

                                        return (
                                            <Chip
                                                key={role.id}
                                                icon={<SecurityIcon />}
                                                label={role.display_name?.toUpperCase()}
                                                color={selected ? "success" : "default"}
                                                variant={selected ? "filled" : "outlined"}
                                                onClick={() => {
                                                    let updated = { ...field.value };

                                                    if (selected) {
                                                        if (userAlreadyHas) {
                                                            updated.remove = [...(updated.remove || []), role.id];
                                                        } else {
                                                            updated.add = (updated.add || []).filter((id: any) => id !== role.id);
                                                        }
                                                    } else {
                                                        if (!userAlreadyHas) {
                                                            updated.add = [...(updated.add || []), role.id];
                                                        }
                                                        updated.remove = (updated.remove || []).filter((id: any) => id !== role.id);
                                                    }

                                                    field.onChange(updated);
                                                }}
                                                sx={{ cursor: "pointer", fontWeight: 600, fontFamily: 'inter, sans-serif' }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                        />
                        <Divider sx={{ my: 3 }} />

                        {/* Torneios */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Torneios do Usuário
                            </Typography>
                            <AddCircleOutlineIcon
                                sx={{ cursor: 'pointer' }}
                                onClick={() => setTournamentModalOpen(true)}
                            />
                        </Box>

                        <Controller
                            name="tournaments"
                            control={control}
                            defaultValue={{ add: [], remove: [] }} // 👈 sempre objeto
                            render={({ field }) => {
                                const value = field.value || { add: [], remove: [] };

                                return (
                                    <>
                                        {user.tournaments?.map((t: any) => {
                                            const isRemoved = value.remove.includes(t.id);
                                            const isAdded = value.add.includes(t.id);

                                            // não renderiza se foi marcado para remover
                                            if (isRemoved) return null;

                                            return (
                                                <ListItem
                                                    key={t.id}
                                                    secondaryAction={
                                                        <CloseIcon
                                                            sx={{ cursor: "pointer", color: "error.main" }}
                                                            onClick={() => {
                                                                let updated = { ...value };

                                                                if (user.tournaments.some((ut: any) => ut.id === t.id)) {
                                                                    // já estava no banco → marcar para remover
                                                                    if (!updated.remove.includes(t.id)) {
                                                                        updated.remove = [...updated.remove, t.id];
                                                                    }
                                                                } else {
                                                                    // era um add temporário → tirar de add
                                                                    updated.add = updated.add.filter((id: number) => id !== t.id);
                                                                }

                                                                // garante sempre o formato { add, remove }
                                                                field.onChange({
                                                                    add: updated.add || [],
                                                                    remove: updated.remove || [],
                                                                });
                                                            }}
                                                        />
                                                    }
                                                >
                                                    <ListItemIcon>
                                                        <EventIcon color="action" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={t.name?.toUpperCase()} />
                                                </ListItem>
                                            );
                                        })}

                                        {/* Se não tiver nenhum torneio (ou todos removidos) */}
                                        {(!user.tournaments || user.tournaments.length === 0 || value.remove.length === user.tournaments.length) && (
                                            <Typography variant="body2" color="text.secondary">
                                                Nenhum torneio vinculado
                                            </Typography>
                                        )}
                                    </>
                                );
                            }}
                        />

                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
                            Vincular torneios
                        </Typography>
                        {selectedTournaments.length > 0 ? (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                {tournaments
                                    .filter((t: any) => selectedTournaments.includes(t.id))
                                    .map((t: any) => (
                                        <Chip
                                            key={t.id}
                                            icon={<EventIcon />}
                                            label={t.name}
                                            color="secondary"
                                            variant="outlined"
                                        />
                                    ))}
                            </Box>
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                Nenhum torneio selecionado
                            </Typography>
                        )}

                    </FormContainer>
                </Box>

                <Content>
                    <FormContainer onSubmit={handleSubmit(onSubmit)}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Informações pessoais
                        </Typography>
                        <FormGroup>
                            <Input
                                label="Nome"
                                name="name"
                                type="text"
                                register={register}
                                required
                                hasError={!!errors.name}
                                error="Este campo é obrigatório"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                label="Nome da mãe"
                                name="mother_name"
                                type="text"
                                register={register}
                                required
                                hasError={!!errors.mother_name}
                                error="Este campo é obrigatório"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Select
                                label="Sexo"
                                name="genre"
                                register={register}
                                required
                                hasError={!!errors.genre}
                                error="Este campo é obrigatório"
                                options={[
                                    { title: "Masculino", option: "masculino" },
                                    { title: "Feminino", option: "feminino" },
                                ]}
                            />
                        </FormGroup>
                        <FormGroup>
                            <InputMaskCustom
                                label="Telefone"
                                name="phone"
                                mask="(99) 99999-9999"
                                register={register}
                                required
                                placeholder={phone}
                                hasError={!!errors.phone}
                                error="Este campo é obrigatório"
                            />
                        </FormGroup>
                        <FormGroup>
                            <InputMaskCustom
                                label="Data de nascimento"
                                name="birth_date"
                                mask="99/99/9999"
                                placeholder={birth_date}
                                register={register}
                                required
                                hasError={!!errors.birth_date}
                                error="Este campo é obrigatório"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                label="Academia"
                                name="gym"
                                type="text"
                                register={register}
                                required
                                hasError={!!errors.gym}
                                error="Este campo é obrigatório"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Select
                                label="Faixa"
                                name="belt"
                                register={register}
                                required
                                hasError={!!errors.belt}
                                error="Este campo é obrigatório"
                                options={belts}
                            />
                        </FormGroup>
                        <Button type="submit" label="Atualizar Usuário" disabled={disabled} />
                    </FormContainer>
                </Content>
            </Box>
            <br />

            <Dialog open={tournamentModalOpen} onClose={() => setTournamentModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Vincular Torneios</DialogTitle>
                <DialogContent dividers>
                    <List>
                        {tournaments.map((t: any) => (
                            <ListItem
                                key={t.id}
                                component="button"
                                onClick={() => {
                                    setSelectedTournaments((prev) =>
                                        prev.includes(t.id) ? prev.filter((id) => id !== t.id) : [...prev, t.id]
                                    );
                                }}
                                sx={{ width: "100%", textAlign: "left" }}
                            >
                                <Checkbox checked={selectedTournaments.includes(t.id)} />
                                <ListItemText sx={{ fontFamily: 'inter, sans-serif' }} primary={t.name?.toLocaleUpperCase()} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button
                        label="Confirmar"
                        onClick={() => {
                            const current = getValues("tournaments") || { add: [], remove: [] };

                            const updated = {
                                add: [...new Set([...current.add, ...selectedTournaments])],
                                remove: current.remove.filter((id: number) => !selectedTournaments.includes(id)), // se estava marcado para remover, tira
                            };

                            setValue("tournaments", updated);
                            setTournamentModalOpen(false);
                        }}
                    />
                    <Button
                        label="Cancelar"
                        onClick={() => setTournamentModalOpen(false)}
                    />
                </DialogActions>
            </Dialog>

        </>
    );
};
